import { FaRegUserCircle } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaBed } from "react-icons/fa";
import { FaBookReader } from "react-icons/fa";
import { FaUserMd } from "react-icons/fa";
import { FaCogs } from "react-icons/fa";
import { FaPlusCircle } from "react-icons/fa";

import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Relaxation1 = () => {
  return (
    <div>
      <main id="main-section">
        <div className="w-full ">
          {/* SIDE-PROFILE DASHBOARD */}

          {/* RELAXATION OPTIONS SECTION */}
          <section className="bg-[#F5F5F5] h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md ">
            <div className="h-full px-3 py-4 overflow-y-auto">
              <div>
                <p className="text-[#314C1C] text-2xl px-4 pb-3 font-bold">
                  RELAXATION
                </p>
                <p className="text-[#314C1C] text-lg px-4 font-semibold ">
                  EXPLORE YOUR RELAXATION TECHNIQUES
                </p>
              </div>
              <div className="text-center">
                <div className="p-8 pt-28">
                  <Link to="relaxation23">
                    <button
                      type="button"
                      className=" text-[#314C1C] border border-[#314C1C] p-4 px-20 rounded-md"
                    >
                      <p className="font-semibold text-lg">Categories</p>
                      <div>
                        <i className="fa-solid fa-layer-group text-2xl" />
                      </div>
                      <p>Find different exercise categories</p>
                    </button>
                  </Link>
                </div>
                <a href>
                  <div>
                    <Link to="relaxation11">
                      <button
                        type="button"
                        className=" text-[#314C1C] border border-[#314C1C] p-4 px-16 rounded-md"
                      >
                        <p className="font-semibold text-lg">Favourites</p>

                        <div>
                          <i className="fa-solid fa-heart text-2xl" />
                        </div>
                        <p className="text-sm">
                          Quick access to all your favourite exercises!
                        </p>
                      </button>
                    </Link>
                  </div>
                </a>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Relaxation1;
